import {
    BanknotesIcon,
    BellAlertIcon,
    BellIcon,
    CheckCircleIcon,
    CheckIcon,
    FireIcon,
    XCircleIcon,
} from '@heroicons/react/20/solid';
import type { OrderStatus, PaymentStatus } from '../../types/Order';
import type { ChipVariant, IconType } from './Chip';

export interface StatusMeta {
    tone: ChipVariant;
    icon: IconType | undefined;
    /** i18n key in the common namespace */
    labelKey: string;
}

export const ORDER_STATUS: Record<OrderStatus, StatusMeta> = {
    pending: { tone: 'action', icon: BellAlertIcon, labelKey: 'status.pending' },
    accepted: { tone: 'outline-info', icon: CheckIcon, labelKey: 'status.accepted' },
    preparing: { tone: 'info', icon: FireIcon, labelKey: 'status.preparing' },
    ready: { tone: 'success-solid', icon: BellIcon, labelKey: 'status.ready' },
    completed: { tone: 'neutral', icon: CheckCircleIcon, labelKey: 'status.completed' },
    cancelled: { tone: 'danger', icon: XCircleIcon, labelKey: 'status.cancelled' },
};

export const PAYMENT_STATUS: Record<PaymentStatus, StatusMeta> = {
    paid: { tone: 'success', icon: BanknotesIcon, labelKey: 'status.paid' },
    unpaid: { tone: 'outline', icon: undefined, labelKey: 'status.unpaid' },
};

/** Payment is due once the food is out; the chip then asks for it. */
export const COLLECT_PAYMENT: StatusMeta = { tone: 'action', icon: BanknotesIcon, labelKey: 'status.collectPayment' };

export const ORDER_FLOW: readonly OrderStatus[] = ['pending', 'accepted', 'preparing', 'ready', 'completed'];

export const NEXT_STATUS: Partial<Record<OrderStatus, OrderStatus>> = {
    pending: 'accepted',
    accepted: 'preparing',
    preparing: 'ready',
    ready: 'completed',
};

/** Label of the single forward button per status (i18n keys, common namespace). */
export const ADVANCE_LABEL_KEY: Partial<Record<OrderStatus, string>> = {
    pending: 'status.advance.pending',
    accepted: 'status.advance.accepted',
    preparing: 'status.advance.preparing',
    ready: 'status.advance.ready',
};
